// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Container } from './container';

/**
 * @class Jsw.CollapsibleBlock
 * @extends Jsw.Container
 *
 * Example usage:
 *
 *     @example
 *     new Jsw.CollapsibleBlock({
 *         renderTo: document.body,
 *         cls: 'example',
 *         title: 'Collapsible block',
 *         items: [
 *             new Jsw.Box({
 *                 html: 'Content of collapsible block.'
 *             })
 *         ]
 *     });
 */
export const CollapsibleBlock = Class.create(Container, {
    /**
     * @cfg {Boolean} collapsed=true
     */
    /**
     * @cfg {String} title
     */

    _initConfiguration($super, config) {
        $super(config);

        this._blockAreaId = `${this._id}-block`;
        this._titleAreaId = `${this._id}-title-area`;
        this._contentAreaId = `${this._id}-content-area`;
    },

    _initComponentElement($super) {
        $super();

        const containerContentChilds = this._componentElement.childElements();

        this._updateComponentElement(
            `<div class="${this._cls}-block${this._getConfigParam('collapsed', true) ? ' hide' : ''}" id="${this._blockAreaId}">` +
                `<div class="${this._cls}-title" id="${this._titleAreaId}">` +
                    `<span>${this._getConfigParam('title', '')}</span>` +
                '</div>' +
                `<div class="${this._cls}-content" id="${this._contentAreaId}"></div>` +
            '</div>'
        );
    },

    _addEvents($super) {
        $super();
        $(this._titleAreaId).down('span').observe('click', this._onTitleClickEvent.bind(this));
    },

    _onTitleClickEvent(event) {
        Event.stop(event);
        $(this._blockAreaId).toggleClassName('hide');
    },
});



// WEBPACK FOOTER //
// ./jsw/collapsible-block.js